export type PermissionTelemetryContext = {
  route?: string;
};

/**
 * UI-layer telemetry until analytics / dashboards consume structured logs.
 * Search logs for `[permissions]` or event keys below.
 */
export const trackBlockedPermissionAction = (
  actionId: string,
  tupleSummary: string,
  context?: PermissionTelemetryContext,
): void => {
  console.warn("[permissions] blocked_action", {
    event: "rbac_denied_action",
    actionId,
    tuple: tupleSummary,
    ...context,
    timestamp: Date.now(),
  });
};

export const trackUnauthorizedRouteAccess = (payload: {
  routeId: string;
  featureKeys: readonly string[];
}): void => {
  console.warn("[permissions] unauthorized_route", {
    event: "rbac_unauthorized_route",
    ...payload,
    timestamp: Date.now(),
  });
};

export const trackRbacMutationOutcome = (payload: {
  operation: string;
  outcome: "success" | "denied";
  tupleSummary?: string;
}): void => {
  console.warn("[permissions] rbac_mutation", {
    event: "rbac_mutation_outcome",
    ...payload,
    timestamp: Date.now(),
  });
};

let menuRebuildSequence = 0;

/** Call after building main/footer menu so sessions can correlate visibility with permissions. */
export const recordMenuRebuild = (payload: {
  kind: "main" | "footer";
  visibleTopLevelCount: number;
}): void => {
  menuRebuildSequence += 1;
  console.warn("[permissions] menu_rebuild", {
    event: "rbac_menu_filtered",
    sessionSequence: menuRebuildSequence,
    ...payload,
    timestamp: Date.now(),
  });
};

/** @internal testing */
export const resetMenuTelemetryForTests = (): void => {
  menuRebuildSequence = 0;
};
